export enum CrmInteractionRating {
	Positive = 0,
	Neutral = 1,
	Negative = 2,
}
